// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iR","advertCardHeader__actions":"c-a_iS","advertCardHeader__bottomLabel":"c-a_iT"};